import { FC, ReactNode, createContext, useEffect, useMemo, useRef, useState } from "react"

import { useLocation, useSearchParams } from "react-router"

export const HistoryContext = createContext({
  lastPage: null as string | null,
})

export const HistoryContextProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { pathname } = useLocation()
  const [params] = useSearchParams()
  const [lastPage, setLastPage] = useState<string | null>(null)
  const currentPage = useRef([pathname, params.toString()].filter(Boolean).join("?"))
  useEffect(() => {
    const newPath = [pathname, params.toString()].filter(Boolean).join("?")
    if (pathname === "/" || pathname.startsWith("/settings")) {
      return
    }
    if (currentPage.current !== lastPage && currentPage.current !== newPath) {
      setLastPage(currentPage.current)
    }
    currentPage.current = newPath
  }, [lastPage, params, pathname])

  const fields = useMemo(() => ({ lastPage }), [lastPage])

  return <HistoryContext.Provider value={fields}>{children}</HistoryContext.Provider>
}
export default HistoryContext
